/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_IntroInputs */

const en_to_typescript_intro = /** @type {(inputs: To_Typescript_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a sample payload into TypeScript interfaces. Every nested object becomes its own named interface, and mixed arrays become union types.`)
};

const ko_to_typescript_intro = /** @type {(inputs: To_Typescript_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`샘플 페이로드를 TypeScript 인터페이스로 바꿉니다. 중첩된 각 객체는 이름이 붙은 자체 인터페이스가 되고, 혼합 배열은 유니온 타입이 됩니다.`)
};

const ja_to_typescript_intro = /** @type {(inputs: To_Typescript_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンプルのペイロードを TypeScript のインターフェースに変換します。ネストした各オブジェクトは名前付きの独自インターフェースになり、混在した配列はユニオン型になります。`)
};

/**
* | output |
* | --- |
* | "Turn a sample payload into TypeScript interfaces. Every nested object becomes its own named interface, and mixed arrays become union types." |
*
* @param {To_Typescript_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_intro = /** @type {((inputs?: To_Typescript_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_intro(inputs)
	if (locale === "ko") return ko_to_typescript_intro(inputs)
	return ja_to_typescript_intro(inputs)
});